import { Col, Row } from 'antd';
import QualityGagesTable from '../../components/QualityGagesTable';

import Header from '../../components/Header';
import { Link } from 'react-router-dom';

const QualityGages = () => {
	return (
		<>
			<Header
				title="Quality Gages"
				breadcrumbItems={[
					{
						title: <Link to="/">Home</Link>,
					},
					{
						title: 'Quality',
					},
					{
						title: 'Gages',
					},
				]}
			/>
			<Row>
				<Col span={24}>
					<QualityGagesTable />
				</Col>
			</Row>
		</>
	);
};

export default QualityGages;
